import React from 'react';
import LeadStagesMaster from '../components/masters/LeadStagesMaster';

const LeadStages = () => {
  return <LeadStagesMaster />;
};

export default LeadStages;